const { MessagePayload } = require('message-components');

const deps = [require('ngreact').name];

/**
 * This module is wrapping a tree of functionality that is marked for deletion,
 * since the feature never got rolled out to users.
 * @see https://benchco.atlassian.net/browse/CX-313
 */
module.exports = angular
  .module('bench.ui.web.oldMessagePayload', deps)
  .directive('oldMessagePayload', reactDirective =>
    reactDirective(MessagePayload, ['payload', 'serviceBubbles', 'handleLinkFormat']),
  );
